import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { OfflineDatabaseCatalog } from '../database/offlineDatabase/types/offlineDatabaseCatalog.types';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';
import {
  PageWithNameSearchOutput,
  PageWithNameSearchParams,
} from './types/offlineCatalogs.repository.types';

const commonRepository = createOfflineCommonRepository<OfflineDatabaseCatalog, 'id'>(
  () => offlineDatabase.catalogs,
);

export const offlineCatalogsRepository = {
  ...commonRepository,
  async pageWithNameSearch({
    limit,
    skip,
    query,
  }: PageWithNameSearchParams): Promise<PageWithNameSearchOutput> {
    const catalogs = await offlineDatabase.catalogs.orderBy('position').toArray();
    const normalizedQuery = query?.trim().toLowerCase();

    const filteredCatalogs = normalizedQuery
      ? catalogs.filter((catalog) => catalog.name?.toLowerCase().includes(normalizedQuery))
      : catalogs;

    return {
      count: filteredCatalogs.length,
      data: filteredCatalogs.slice(skip, skip + limit),
    };
  },
  findByCustomerOrClassification(customerId: string, classificationIds: string[]) {
    const databaseTable = offlineDatabase.catalogs;
    return databaseTable
      .filter((catalog) => {
        const hasCatalogRestrictions =
          !!catalog.classificationIds.length ||
          !!catalog.customerIds.length ||
          !!catalog.salesRepresentativeIds.length;

        return (
          !hasCatalogRestrictions ||
          catalog.customerIds.includes(customerId) ||
          catalog.classificationIds.some((id) => classificationIds.includes(id))
        );
      })
      .toArray();
  },
};
